// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { secondaryNavigationStyles } from "@stoneage/Overrides/Widgets/Header/SecondaryNavigation";
import { css } from "styled-components";
import { color, layoutContainer, xScreen } from "@stoneage/XDL/Utilities";

secondaryNavigationStyles.wrapper = {
    css: css`
        background-color: ${color("common.black")};
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

secondaryNavigationStyles.innerWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 20px;
        ${layoutContainer}
    `,
};

secondaryNavigationStyles.languageLink = {};

secondaryNavigationStyles.currencyLink = {};

secondaryNavigationStyles.warehousePickupLink = {};
